function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import * as React from 'react';
import SpzaComponent from '../spzaComponent';
import { SortedTableColumn } from './sortedTableColumn';
const SortOrder = {
    None: 'none',
    Ascending: 'ascending',
    Descending: 'descending'
};
function SortArrayByProperty(inputArray, propertyName, order) {
    const comparer = function(arg0, arg1) {
        if (typeof arg0[`${propertyName}`] !== 'number' || typeof arg1[`${propertyName}`] !== 'number') {
            return 0;
        }
        return order === SortOrder.Ascending ? arg0[`${propertyName}`] - arg1[`${propertyName}`] : arg1[`${propertyName}`] - arg0[`${propertyName}`];
    };
    return inputArray.sort(comparer);
}
export class SortedTable extends SpzaComponent {
    renderImpl() {
        var _multiLineRowsConfiguration_multilineColumns;
        const { multiLineRowsConfiguration, tbody, defaultSortingDisabled } = this.props;
        let tableData = defaultSortingDisabled ? tbody : tbody.sort((a, b)=>{
            const titleA = a.title ? a.title.toUpperCase() : a.category.toUpperCase();
            const titleB = b.title ? b.title.toUpperCase() : b.category.toUpperCase();
            return titleA < titleB ? 1 : titleA > titleB ? -1 : 0;
        });
        tableData = this.props.sortConfig.sortColumnName ? SortArrayByProperty(tableData, this.props.sortConfig.sortColumnName, this.props.sortConfig.sortOrder) : tableData;
        const hasMultilineConfig = !!(multiLineRowsConfiguration === null || multiLineRowsConfiguration === void 0 ? void 0 : (_multiLineRowsConfiguration_multilineColumns = multiLineRowsConfiguration.multilineColumns) === null || _multiLineRowsConfiguration_multilineColumns === void 0 ? void 0 : _multiLineRowsConfiguration_multilineColumns.length);
        const rowRenderingFunction = hasMultilineConfig ? this.renderMultilineRow(multiLineRowsConfiguration) : this.renderOldSingleLineRow;
        return /*#__PURE__*/ _jsxs("table", {
            "data-f-sort": "true",
            children: [
                /*#__PURE__*/ _jsx("thead", {
                    children: this.props.thead
                }),
                /*#__PURE__*/ _jsx("tbody", {
                    children: tableData.map((row)=>rowRenderingFunction(row))
                })
            ]
        });
    }
    constructor(...args){
        super(...args), // This is the old implementation of the component and new implemnantion is under multiyear feature flag
        _define_property(this, "renderOldSingleLineRow", (row)=>{
            const columns = [];
            Object.keys(row).forEach((propertyName)=>{
                // If this flag is set the property is not rendered. Default - property is rendered.
                const shouldIgnore = this.props.ignore ? this.props.ignore.indexOf(propertyName) >= 0 : false;
                // If this flag is set a span tag is added around the content of table data. Default - no span tag added.
                const shouldAddSpanTag = this.props.spanColumns ? this.props.spanColumns.indexOf(propertyName) >= 0 : false;
                // If this flag is set, we will use dangerouslySetInnerHTML
                const shouldUseSetInnerHTML = this.props.setInnerHTMLColumns ? this.props.setInnerHTMLColumns.indexOf(propertyName) >= 0 : false;
                // If this flag is set the content of table data can have breaks within it. Default - A single line.
                const shouldShowMultiLine = this.props.multiLineColumns ? this.props.multiLineColumns.indexOf(propertyName) >= 0 : false;
                if (!shouldIgnore && row[`${propertyName}`]) {
                    if (row[`${propertyName}`] instanceof Array && shouldShowMultiLine) {
                        if (row[`${propertyName}`]) {
                            const lines = row[`${propertyName}`].map(function(item, key) {
                                if (shouldUseSetInnerHTML) {
                                    return(// eslint-disable-next-line react/no-danger
                                    /*#__PURE__*/ _jsx("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: item
                                        },
                                        children: /*#__PURE__*/ _jsx("br", {})
                                    }, key));
                                }
                                return /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        item,
                                        /*#__PURE__*/ _jsx("br", {})
                                    ]
                                }, key);
                            });
                            columns.push(// eslint-disable-next-line react/forbid-dom-props
                            /*#__PURE__*/ _jsx("td", {
                                id: propertyName,
                                className: propertyName,
                                children: lines
                            }));
                        }
                    } else if (typeof row[`${propertyName}`] === 'string' || typeof row[`${propertyName}`] === 'number' || typeof row[`${propertyName}`] === 'object') {
                        if (shouldAddSpanTag) {
                            columns.push(// eslint-disable-next-line react/forbid-dom-props
                            /*#__PURE__*/ _jsx("td", {
                                id: propertyName,
                                className: propertyName,
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: row[`${propertyName}`]
                                })
                            }));
                        } else if (shouldUseSetInnerHTML) {
                            columns.push(/*#__PURE__*/ _jsx("td", {
                                // eslint-disable-next-line react/forbid-dom-props
                                id: propertyName,
                                className: propertyName,
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML: {
                                    __html: row[`${propertyName}`]
                                }
                            }));
                        } else {
                            columns.push(// eslint-disable-next-line react/forbid-dom-props
                            /*#__PURE__*/ _jsx("td", {
                                id: propertyName,
                                className: propertyName,
                                children: row[`${propertyName}`]
                            }));
                        }
                    }
                }
            });
            return /*#__PURE__*/ _jsx("tr", {
                className: row.rowClassName,
                children: columns
            }, row.rowKey);
        }), _define_property(this, "getColumnKeysToRender", (row)=>{
            if (!row) {
                return [];
            }
            const { columns } = this.props;
            if (columns) {
                return columns;
            }
            return Object.keys(row).filter((columnKey)=>{
                var _this_props_ignore;
                const columnValue = row[columnKey.toString()];
                const shouldIgnore = (_this_props_ignore = this.props.ignore) === null || _this_props_ignore === void 0 ? void 0 : _this_props_ignore.some((ignoreKey)=>ignoreKey === columnKey);
                return columnValue && !shouldIgnore;
            });
        }), _define_property(this, "renderSingleLineRow", (row)=>{
            const { columnsClasses } = this.props;
            const columns = this.getColumnKeysToRender(row).map((columnKey)=>/*#__PURE__*/ _jsx(SortedTableColumn, {
                    columnKey: columnKey,
                    className: columnsClasses === null || columnsClasses === void 0 ? void 0 : columnsClasses[`${columnKey}`],
                    columnValue: row[`${columnKey}`],
                    tableProps: this.props
                }, columnKey));
            return /*#__PURE__*/ _jsx("tr", {
                className: row.rowClassName,
                children: columns
            }, row.rowKey);
        }), _define_property(this, "renderMultilineRow", (multilineConfig)=>(rowData)=>{
                var _rowData_multilineColumns_;
                const { columnsClasses } = this.props;
                const { multilineColumns, emptyColumnClassName, lastRowClassName, multilineColumnClass } = multilineConfig;
                if (!multilineColumns.length) {
                    return null;
                }
                const numberOfMultilineRows = ((_rowData_multilineColumns_ = rowData[multilineColumns[0]]) === null || _rowData_multilineColumns_ === void 0 ? void 0 : _rowData_multilineColumns_.length) || 0;
                const rows = [];
                for(let rowIndex = 0; rowIndex < numberOfMultilineRows; rowIndex++){
                    const columns = this.getColumnKeysToRender(rowData).map((columnKey)=>{
                        const columnValue = rowData[columnKey.toString()];
                        const isMultilineColumn = multilineColumns.find((x)=>x === columnKey);
                        if (rowIndex === 0) {
                            return /*#__PURE__*/ _jsx(SortedTableColumn, {
                                columnKey: columnKey,
                                columnValue: isMultilineColumn ? columnValue[`${rowIndex}`] : columnValue,
                                tableProps: this.props,
                                className: classNames(columnsClasses === null || columnsClasses === void 0 ? void 0 : columnsClasses[`${columnKey}`], {
                                    [multilineColumnClass]: isMultilineColumn
                                })
                            }, columnKey);
                        } else {
                            if (isMultilineColumn) {
                                return /*#__PURE__*/ _jsx(SortedTableColumn, {
                                    columnKey: columnKey,
                                    columnValue: columnValue[`${rowIndex}`],
                                    tableProps: this.props,
                                    className: classNames(multilineColumnClass, columnsClasses === null || columnsClasses === void 0 ? void 0 : columnsClasses[`${columnKey}`])
                                }, columnKey);
                            } else {
                                return /*#__PURE__*/ _jsx("td", {
                                    className: classNames(columnKey, emptyColumnClassName, columnsClasses === null || columnsClasses === void 0 ? void 0 : columnsClasses[`${columnKey}`])
                                }, columnKey);
                            }
                        }
                    });
                    rows.push(columns);
                }
                return rows.map((row, index)=>/*#__PURE__*/ _jsx("tr", {
                        className: `${rowData.rowClassName} ${index === rows.length - 1 ? lastRowClassName : ''}`,
                        children: row
                    }, rowData.rowKey));
            });
    }
}
